import { Component, HostListener, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AgilityRiskUnsavedChangesGuardService } from '../../../providers/agility-risk-unsaved-changes-guard.service';

@Component({
  template: ''
})
export class BaseComponent implements OnDestroy {
  public isDirty = false;

  constructor(public activatedRoute: ActivatedRoute) {
    if (activatedRoute.routeConfig.canDeactivate && Array.isArray(activatedRoute.routeConfig.canDeactivate)) {
      if (activatedRoute.routeConfig.canDeactivate.findIndex(guard => guard === AgilityRiskUnsavedChangesGuardService) === -1) {
        activatedRoute.routeConfig.canDeactivate = [...activatedRoute.routeConfig.canDeactivate, AgilityRiskUnsavedChangesGuardService];
      }
    } else {
      activatedRoute.routeConfig.canDeactivate = [AgilityRiskUnsavedChangesGuardService];
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any) {
    if (this.isDirty) {
      $event.returnValue = true;
    }
  }

  ngOnDestroy() {
    this.activatedRoute.routeConfig.canDeactivate = this.activatedRoute.routeConfig.canDeactivate.filter(guard => guard !== AgilityRiskUnsavedChangesGuardService);
  }
}
